export function PeriodPickerController($scope, ScheduleService, STRATEGIES_ENUM) {

    $scope.minDate = new Date(Date.now());

    this.$onInit = function () {
        let trigger = this.trigger;
        trigger.startAt = trigger.startAt == null ? new Date(Date.now()) : trigger.startAt;
        let defaultRunUntill = new Date(Date.now());
        defaultRunUntill.setDate(defaultRunUntill.getDate() + 1);
        trigger.runUntil = trigger.runUntil == null ? defaultRunUntill : trigger.runUntil;
        $scope.trigger = trigger;
        $scope.STRATEGIES_ENUM = STRATEGIES_ENUM;
    };

    $scope.onStrategyChanged = function () {
        switch ($scope.trigger.strategy) {
            case STRATEGIES_ENUM.RUN_FOR_PERIOD.value:
            case STRATEGIES_ENUM.RUN_STARTING_FROM.value: {
                $scope.trigger
            }
        }

    }
}

